import request from '@/utils/request'

/**
 * 删除员工权限
 * @param {Object} data 请求参数
 * @returns {Promise} 返回Promise对象
 */
export function deleteStaffPrivilege(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/system.deleteStaffPrivilege',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 关闭删除确认弹窗
 * @returns {Promise} 返回Promise对象
 */
export function closeDeleteModal() {
  return new Promise((resolve) => {
    resolve({ code: 200, message: '弹窗已关闭' })
  })
}